// extracted by mini-css-extract-plugin
module.exports = {"internal_links_area":"InternalLinksInRanking_internal_links_area__vnSAN","internal_link_button":"InternalLinksInRanking_internal_link_button__I1NRy"};